/* ScrollTo */
document.addEventListener('DOMContentLoaded', () => {
    const scrollToTarget = document.querySelector('.skipToMainTrigger');

    if (!scrollToTarget) return;

    document.querySelectorAll('.scrollToButton').forEach((button) => {
        button.addEventListener('click', () => {
            scrollToTarget.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });

            scrollToTarget.focus();
        });
    });
});
